
<span
class="flex h-10 w-10 items-center justify-center rounded-full bg-rose-800 text-white"
>{{user.first_name[0] | uppercase | titlecase}}{{user.last_name[0] | uppercase | titlecase}}</span
>